/**
 * Central GSAP instance with ScrollTrigger registered once.
 *
 * Import `{ gsap, ScrollTrigger }` from here everywhere instead of from the
 * package directly, so the plugin is only ever registered a single time and
 * only in the browser (registration touches `document`).
 */
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger)
}

export { gsap, ScrollTrigger }
